// extracted by mini-css-extract-plugin
export default {"root":"AddEventButton_root__tIJTN","btn":"AddEventButton_btn__OM5kI"};